import { ProductRouteConfig } from './RouteConfig.types';

export const routeConfig: ProductRouteConfig = {
  SCF: {
    profile: {
      component: 'Profile',
      // allowedPaths: ['profile'],
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: 'identifier',
      },
    },
    identifier: {
      component: 'USBusinessIdentifier',
      // allowedPaths: ['profile', 'identifier'],
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: 'details',
      },
    },
    details: {
      component: 'USBusinessDetails',
      // allowedPaths: ['profile', 'identifier', 'details'],
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: 'eligibility',
      },
    },
    eligibility: {
      component: 'USBusinessEligibility',
      // allowedPaths: ['profile', 'identifier', 'details', 'eligibility'],
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: 'granted',
      },
    },
    denied: {
      component: 'USEligibleDenied',
      // allowedPaths: [
      //   'profile',
      //   'identifier',
      //   'details',
      //   'eligibility',
      //   'denied',
      // ],
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: '',
      },
    },
    applicants: {
      component: 'USApplicants',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [
        'applicants',
        'creation',
        'registration',
        'personal',
        'company',
        'onboarding-intro',
        'onboarding',
        'bank',
        'identity',
        'financial',
        'track_application',
      ],
      cpAllowedPaths: [
        'applicants',
        'registration',
        'creation',
        'onboarding-intro',
        'onboarding',
        'track_application',
      ],
      props: {
        nextStage: '',
      },
    },
    legal: {
      component: 'USLegalDocs',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: ['legal', 'applicants'],
      props: {
        nextStage: '',
      },
    },
    approved: {
      component: 'USApprovedStage',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      cpAllowedPaths: ['approved', 'applicants'],
      props: {
        nextStage: '',
      },
    },
    'legal-generated': {
      component: 'USLegalGenerated',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: ['legal-generated', 'applicants'],
      props: {
        nextStage: '',
      },
    },
    rejected: {
      component: 'USLegalRejected',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: ['rejected', 'applicants'],
      cpAllowedPaths: ['rejected', 'applicants'],
      props: {
        nextStage: '',
      },
    },
    creation: {
      component: 'USAssistedCreateAccount',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: ['applicants', 'creation'],
      cpAllowedPaths: ['applicants', 'creation', 'application'],
      props: {
        nextStage: 'registration',
      },
    },
    registration: {
      component: 'USAssistedRegisterCompany',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: ['applicants', 'creation', 'registration'],
      cpAllowedPaths: ['applicants', 'creation', 'registration'],
      props: {
        nextStage: 'application',
      },
    },
    onboard: {
      component: 'USCustomerLanding',
      allowedPaths: [],
      uAllowedPaths: ['onboard', 'personal', 'bank', 'financial', 'review'],
      suAllowedPaths: [],
      props: {
        nextStage: 'personal',
      },
    },
    personal: {
      component: 'USPersonalDetails',
      allowedPaths: [],
      uAllowedPaths: [
        'introduction',
        'onboard',
        'personal',
        'company',
        'onboarding',
        'bank',
        'identity',
        'financial',
        'review',
        'application',
      ],
      suAllowedPaths: [
        'introduction',
        'creation',
        'application',
        'personal',
        'company',
        'onboarding',
        'financial',
        'identity',
        'bank',
        'applicants',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
        'application',
      ],
      props: {
        nextStage: 'bank',
      },
    },
    company: {
      component: 'USCompanyDetails',
      allowedPaths: [],
      uAllowedPaths: [
        'introduction',
        'onboard',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'review',
        'application',
      ],
      suAllowedPaths: [
        'introduction',
        'creation',
        'application',
        'personal',
        'company',
        'onboarding',
        'financial',
        'identity',
        'bank',
        'applicants',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
        'application',
      ],
      props: {
        nextStage: 'personal',
      },
    },
    // Landing page for the revamped US underwriting flow (NDAJ revamp).
    'onboarding-intro': {
      component: 'USOnboardingIntro',
      allowedPaths: [],
      uAllowedPaths: ['onboarding-intro', 'onboarding'],
      suAllowedPaths: ['onboarding-intro', 'onboarding'],
      cpAllowedPaths: ['onboarding-intro', 'onboarding'],
      props: {
        nextStage: 'onboarding',
      },
    },
    onboarding: {
      component: 'USUnderwritingV2',
      allowedPaths: [],
      uAllowedPaths: [
        'introduction',
        'onboard',
        'personal',
        'company',
        'onboarding-intro',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'application',
      ],
      suAllowedPaths: [
        'introduction',
        'creation',
        'application',
        'personal',
        'company',
        'onboarding-intro',
        'onboarding',
        'financial',
        'identity',
        'bank',
        'applicants',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'personal',
        'company',
        'onboarding-intro',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
        'application',
      ],
      props: {
        nextStage: 'personal',
      },
    },
    // V2 post-submission tracking page. Exporter `processing` stage lands here.
    // Also reachable directly by URL from any stage (AuthRouteHOC bypass).
    track_application: {
      component: 'USTrackApplication',
      allowedPaths: ['track_application'],
      uAllowedPaths: ['track_application'],
      suAllowedPaths: ['track_application', 'applicants'],
      cpAllowedPaths: ['track_application'],
      props: {
        nextStage: '',
      },
    },
    bank: {
      component: 'USBankDetails',
      allowedPaths: [],
      uAllowedPaths: [
        'introduction',
        'onboard',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'review',
        'application',
      ],
      suAllowedPaths: [
        'introduction',
        'creation',
        'application',
        'personal',
        'company',
        'onboarding',
        'financial',
        'identity',
        'bank',
        'applicants',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
        'application',
      ],
      props: {
        nextStage: 'financial',
      },
    },
    financial: {
      component: 'USFinancialDetails',
      allowedPaths: [],
      uAllowedPaths: [
        'introduction',
        'onboard',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'review',
        'application',
      ],
      suAllowedPaths: [
        'introduction',
        'creation',
        'application',
        'personal',
        'company',
        'onboarding',
        'financial',
        'identity',
        'bank',
        'applicants',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
        'application',
      ],
      props: {
        nextStage: 'review',
      },
    },
    review: {
      component: 'USReview',
      allowedPaths: [],
      uAllowedPaths: [
        'introduction',
        'onboard',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'review',
        'application',
      ],
      suAllowedPaths: ['bank'],
      props: {
        nextStage: 'application',
      },
    },
    application: {
      component: 'USApplicationStatus',
      allowedPaths: ['onboard', 'application'],
      uAllowedPaths: [],
      suAllowedPaths: [
        'introduction',
        'applicants',
        'creation',
        'registration',
        'personal',
        'financial',
        'company',
        'onboarding',
        'bank',
        'identity',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'personal',
        'registration',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
      ],
      props: {
        nextStage: 'granted',
      },
    },
    limitapproved: {
      component: 'USLimitApproved',
      allowedPaths: [
        'onboard',
        'application',
        'limitapproved',
        // 'legalapplication',
        // 'legalachauthorization',
        // 'legalvirtualsitevisit',
        'postlegalcompleted',
      ],
      uAllowedPaths: [
        'onboard',
        'application',
        'limitapproved',
        // 'legalapplication',
        // 'legalachauthorization',
        // 'legalvirtualsitevisit',
        'postlegalcompleted',
      ],
      suAllowedPaths: [
        'introduction',
        'applicants',
        'creation',
        'registration',
        'personal',
        'financial',
        'company',
        'onboarding',
        'bank',
        'identity',
        'limitapproved',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'postlegalcompleted',
      ],
      cpAllowedPaths: [],
      props: {
        nextStage: 'legalapplication',
      },
    },
    legalapplication: {
      component: 'USLegalApplication',
      allowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'postlegalcompleted',
        'limitapproved',
      ],
      uAllowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'postlegalcompleted',
        'limitapproved',
      ],
      suAllowedPaths: [
        'introduction',
        'applicants',
        'creation',
        'registration',
        'personal',
        'financial',
        'company',
        'onboarding',
        'bank',
        'identity',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'postlegalcompleted',
        'limitapproved',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'personal',
        'registration',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'postlegalcompleted',
        'limitapproved',
      ],
      props: {
        nextStage: 'legalachauthorization',
      },
    },
    legalachauthorization: {
      component: 'USACHAuthorization',
      allowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      uAllowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      suAllowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      cpAllowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      props: {
        nextStage: 'legalvirtualsitevisit',
      },
    },
    legalvirtualsitevisit: {
      component: 'USVirtualSiteVisit',
      allowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      uAllowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      suAllowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      cpAllowedPaths: [
        'onboard',
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      props: {
        nextStage: 'accepted',
      },
    },
    granted: {
      component: 'USOfferGranted',
      // allowedPaths: [],
      // uAllowedPaths: ['granted'],
      // suAllowedPaths: [],
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: 'accepted',
      },
    },
    accepted: {
      component: 'USOfferAccepted',
      // allowedPaths: [],
      // uAllowedPaths: ['accepted'],
      // suAllowedPaths: [],
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: '',
      },
    },
    referrals: {
      component: 'USReferrals',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: '',
      },
    },
    introduction: {
      component: 'USIntroduction',
      allowedPaths: [],
      uAllowedPaths: [
        'introduction',
        'personal',
        'company',
        'onboarding',
        'bank',
        'identity',
        'financial',
        'review',
        'application',
      ],
      suAllowedPaths: [
        'introduction',
        'creation',
        'application',
        'personal',
        'company',
        'onboarding',
        'financial',
        'identity',
        'bank',
        'applicants',
      ],
      cpAllowedPaths: [
        'introduction',
        'creation',
        'personal',
        'company',
        'onboarding',
        'identity',
        'bank',
        'financial',
        'applicants',
        'application',
      ],
      props: {
        nextStage: 'company',
      },
    },
    postlegalcompleted: {
      component: 'USPostLegalCompleted',
      allowedPaths: [
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      uAllowedPaths: [
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      suAllowedPaths: [
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      cpAllowedPaths: [
        'application',
        'legalapplication',
        'legalachauthorization',
        'legalvirtualsitevisit',
        'applicants',
        'postlegalcompleted',
      ],
      props: {
        nextStage: '',
      },
    },
    referral: {
      component: 'USSubmit',
      allowedPaths: [],
      uAllowedPaths: [],
      suAllowedPaths: [],
      props: {
        nextStage: '',
      },
    },
  },
  stages: {
    bdm: {
      applicants: 'applicants',
      // V2 onboarding stages: brand-new applicants land on the intro; all
      // mid-flow stages resume directly in the onboarding form.
      new: 'onboarding-intro',
      creation: 'creation',
      user_details_pending: 'onboarding',
      business_not_registered: 'registration',
      personal_info_pending: 'onboarding',
      company_details_pending: 'onboarding',
      bank_info_pending: 'onboarding',
      finance_info_pending: 'onboarding',
      review_pending: 'onboarding',
      New: 'onboarding-intro',
      // Post-submission: BDM lands on the V2 track-application page.
      processing: 'track_application',
      limit_approved: 'legal',
      post_journey_started: 'legal',
      legal_pending: 'legal',
      post_legal_pending: 'legalachauthorization',
      rejected: 'rejected',
      complete_post_legal_steps: 'legalapplication',
      first_invoice_pending: 'legalapplication',
      first_invoice_added: 'legalapplication',
    },
    exporter: {
      profile: 'profile',
      identifier: 'identifier',
      details: 'details',
      eligibility: 'eligibility',
      denied: 'denied',
      // Revamped US onboarding flow (NDAJ revamp): brand-new users land on the
      // intro; users already mid-flow resume directly in the onboarding form.
      new: 'onboarding-intro',
      user_details_pending: 'onboarding',
      company_details_pending: 'onboarding',
      personal_info_pending: 'onboarding',
      bank_info_pending: 'onboarding',
      finance_info_pending: 'onboarding',
      review_pending: 'onboarding',
      // Post-submission: V2 flow lands on the new TrackApplication page.
      processing: 'track_application',
      granted: 'granted',
      accepted: 'accepted',
      New: 'personal',
      limit_approved: 'limitapproved',
      post_journey_started: 'legalapplication',
      legal_pending: 'legalapplication',
      post_legal_pending: 'legalachauthorization',
      complete_post_legal_steps: 'postlegalcompleted',
      first_invoice_pending: 'postlegalcompleted',
    },
    cp: {
      profile: 'profile',
      identifier: 'identifier',
      details: 'details',
      eligibility: 'eligibility',
      denied: 'denied',
      // V2 onboarding stages (NDAJ revamp): CP drives the same revamped
      // onboarding form as BDM on behalf of the applicant. New applicants land
      // on the intro; mid-flow stages resume directly in the onboarding form.
      new: 'onboarding-intro',
      New: 'onboarding-intro',
      // Post-submission: CP lands on the V2 track-application page.
      processing: 'track_application',
      granted: 'granted',
      accepted: 'accepted',
      applicants: 'applicants',
      personal_info_pending: 'onboarding',
      company_details_pending: 'onboarding',
      user_details_pending: 'onboarding',
      bank_info_pending: 'onboarding',
      finance_info_pending: 'onboarding',
      review_pending: 'onboarding',
      business_not_registered: 'registration',
      // Post-approval: CP has no legal-agreement generation (BDM-only); it
      // continues to land on the approved / legal info screens as before.
      limit_approved: 'approved',
      post_journey_started: 'approved',
      legal_pending: 'approved',
      post_legal_pending: 'legalachauthorization',
      rejected: 'rejected',
      complete_post_legal_steps: 'legalapplication',
      first_invoice_pending: 'legalapplication',
      first_invoice_added: 'legalapplication',
    },
  },
  paths: {
    profile: '/us/scf/profile',
    identifier: '/us/scf/identifier',
    details: '/us/scf/details',
    eligibility: '/us/scf/eligibility',
    denied: '/us/scf/denied',
    applicants: '/us/scf/applicants',
    creation: '/us/scf/creation',
    registration: '/us/scf/registration',
    onboard: '/us/scf/onboard',
    introduction: '/us/scf/introduction',
    personal: '/us/scf/personal',
    company: '/us/scf/company',
    'onboarding-intro': '/us/scf/onboarding-intro',
    onboarding: '/us/scf/onboarding',
    identity: '/us/scf/identity',
    bank: '/us/scf/bank',
    financial: '/us/scf/financial',
    review: '/us/scf/review',
    application: '/us/scf/application',
    track_application: '/us/scf/track_application',
    limitapproved: '/us/scf/limitapproved',
    legalapplication: '/us/scf/legalapplication',
    legalachauthorization: '/us/scf/legalachauthorization',
    legalvirtualsitevisit: '/us/scf/legalvirtualsitevisit',
    granted: '/us/scf/granted',
    accepted: '/us/scf/accepted',
    referrals: '/us/scf/referrals',
    referral: '/us/scf/referral',
    legal: '/us/scf/legal',
    'legal-generated': '/us/scf/legal-generated',
    rejected: '/us/scf/rejected',
    approved: '/us/scf/approved',
    postlegalcompleted: '/us/scf/postlegalcompleted',
  },
};
